import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Modal, Button } from "react-bootstrap";
import SingleLead from '../../components/singlelead';

// Strip Cartesia TTS voice tags (e.g. <emotion value="...">text</emotion>, <trust:medium>, etc.)
function stripVoiceTags(text) {
    if (!text) return text;
    return text.replace(/<[^>]+>/g, '').trim();
}

class TranscriptRenderer extends Component {
    render() {
        return (
            <Button 
                variant="info" 
                size="sm" 
                onClick={() => this.props.context.showTranscript(this.props.value)}
                disabled={!this.props.value}
            >
                View Transcript
            </Button>
        );
    }
}

class SummaryRenderer extends Component {
    render() {
        return (
            <Button 
                variant="primary" 
                size="sm" 
                onClick={() => this.props.context.showSummary(this.props.value)}
                disabled={!this.props.value}
            >
                View Summary
            </Button>
        );
    }
}

class RecordingRenderer extends Component {
    render() {
        return (
            this.props.value ? (
                <audio controls src={this.props.value} style={{ height: '30px', width: '250px' }} />
            ) : null
        );
    }
}

const SHORT_RESULT_CONFIG = {
    NOT_RECEIVED:            { label: 'Not Received',                     bg: '#6c757d', color: '#fff' },
    RECEIVED_BUT_DROPPED:    { label: 'Short Conversation',    bg: '#fd7e14', color: '#fff' },
    IVR:                     { label: 'IVR',                   bg: '#6f42c1', color: '#fff' },
    MAILBOX:                 { label: 'VoiceMail',             bg: '#9b59b6', color: '#fff' },
    INTERESTED:              { label: 'Interested',                        bg: '#198754', color: '#fff' },
    NOT_INTERESTED:          { label: 'Not Interested',                   bg: '#dc3545', color: '#fff' },
    USER_BUSY:               { label: 'User Busy',             bg: '#ffc107', color: '#000' },
    NEED_IMPROVEMENT:        { label: 'Unclear Conversation',  bg: '#6c757d', color: '#fff' },
    NO_CONVERSATION:         { label: 'No Conversation',       bg: '#adb5bd', color: '#000' },
    SHARE_ON_WHATSAPP:       { label: 'Share On WhatsApp',    bg: '#25D366', color: '#fff' },
    SHARED_POINT_OF_CONTACT: { label: 'Shared Point Of Contact', bg: '#20c997', color: '#fff' },
    GAVE_EMAIL:              { label: 'Share On Email',       bg: '#0d6efd', color: '#fff' },
    MEETING_BOOKED:          { label: 'Booked a Meeting',     bg: '#0dcaf0', color: '#000' }
};

class ShortResultRenderer extends Component {
    render() {
        const val = this.props.value;
        if (!val) return null;
        const cfg = SHORT_RESULT_CONFIG[val] || { label: val, bg: '#adb5bd', color: '#000' };
        return (
            <span style={{
                display: 'inline-block',
                padding: '1px 6px',
                borderRadius: '8px',
                fontSize: '10px',
                fontWeight: 500,
                backgroundColor: cfg.bg,
                color: cfg.color,
                whiteSpace: 'nowrap'
            }}>
                {cfg.label}
            </span>
        );
    }
}

const CALL_RESULT_CONFIG = {
    CONNECTED:                { label: 'CONNECTED',               bg: '#198754', color: '#fff' },
    CALL_NOT_RECHABLE:        { label: 'NOT REACHABLE',           bg: '#6c757d', color: '#fff' },
    CALL_BUSY_TRY_AGAIN:      { label: 'BUSY',                    bg: '#fd7e14', color: '#fff' },
    CALL_NOT_FOUND:           { label: 'NOT FOUND',               bg: '#dc3545', color: '#fff' },
    CALL_SERVICE_UNAVAILABLE: { label: 'SERVICE UNAVAILABLE',     bg: '#6f42c1', color: '#fff' },
};

class CallResultRenderer extends Component {
    render() {
        const val = this.props.value;
        if (!val) return null;
        const cfg = CALL_RESULT_CONFIG[val] || { label: val, bg: '#adb5bd', color: '#000' };
        return (
            <span style={{
                display: 'inline-block',
                padding: '1px 6px',
                borderRadius: '8px',
                fontSize: '10px',
                fontWeight: 500,
                backgroundColor: cfg.bg,
                color: cfg.color,
                whiteSpace: 'nowrap'
            }}>
                {cfg.label}
            </span>
        );
    }
}

class LeadLinkRenderer extends Component {
    render() {
        const leadid = this.props.data && this.props.data.leadid;
        const db = this.props.data && this.props.data.db;
        if (!leadid || !db) return null;
        return (
            <a href={`/leaddetails/${db}/${leadid}`} target="_blank" rel="noopener noreferrer">
                View Lead
            </a>
        );
    }
}

class CampaignDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [
                { field: "id", headerName: "ID", width: 80, filter: "agNumberColumnFilter" },
                { field: "contactnumber", headerName: "Phone Number", filter: "agTextColumnFilter" },
                { field: "user_name", headerName: "Name", filter: "agTextColumnFilter", width: 150 },
                { 
                    field: "status", 
                    headerName: "Status", 
                    filter: "agNumberColumnFilter", 
                    width: 120,
                    valueFormatter: params => {
                        if (params.value === 0) return 'Not Started';
                        if (params.value === 1) return 'In Call';
                        if (params.value === 2) return 'Call Ended';
                        return params.value;
                    }
                },
                { 
                    field: "callstatus", 
                    headerName: "Call Status", 
                    filter: "agNumberColumnFilter", 
                    width: 120,
                    valueFormatter: params => params.value === 1 ? 'Success' : ''
                },
                {
                    field: "positivityscore",
                    headerName: "Score",
                    width: 90,
                    filter: "agNumberColumnFilter",
                    sort: "desc"
                },
                {
                    field: "call_result",
                    headerName: "Call Result",
                    cellRenderer: "callResultRenderer",
                    width: 170,
                    filter: "agTextColumnFilter",
                    sortable: true
                },
                {
                    field: "short_result",
                    headerName: "Result",
                    cellRenderer: "shortResultRenderer",
                    width: 160,
                    filter: "agSetColumnFilter",
                    filterParams: {
                        values: ['NOT_RECEIVED', 'RECEIVED_BUT_DROPPED', 'IVR', 'MAILBOX', 'INTERESTED', 'NOT_INTERESTED', 'SHARE_ON_WHATSAPP', 'SHARED_POINT_OF_CONTACT', 'GAVE_EMAIL', 'MEETING_BOOKED']
                    },
                    sortable: true
                },
                {
                    field: "summary",
                    headerName: "Summary",
                    cellRenderer: "summaryRenderer",
                    width: 150,
                    sortable: false,
                    filter: false
                },
                { 
                    field: "transcript", 
                    headerName: "Transcript", 
                    cellRenderer: "transcriptRenderer",
                    width: 150,
                    sortable: false,
                    filter: false
                },
                { 
                    field: "recordingurl", 
                    headerName: "Recording", 
                    cellRenderer: "recordingRenderer",
                    width: 300,
                    sortable: false,
                    filter: false
                },
                { 
                    field: "calldatetime", 
                    headerName: "Call Date", 
                    filter: "agDateColumnFilter",
                    valueFormatter: params => params.value ? new Date(params.value).toLocaleString() : ''
                },
                {
                    field: "usertype",
                    headerName: "User Type",
                    filter: "agTextColumnFilter",
                    width: 120
                },
                {
                    field: "leadid",
                    headerName: "Lead",
                    cellRenderer: "leadLinkRenderer",
                    width: 110,
                    sortable: false,
                    filter: false
                }
            ],
            rowModelType: "serverSide",
            showTranscriptModal: false,
            showSummaryModal: false,
            currentTranscript: "",
            currentSummary: "",
            // showLeadModal: false,
            currentLeadId: null,
            currentLeadDb: null,
            frameworkComponents: {
                transcriptRenderer: TranscriptRenderer,
                summaryRenderer: SummaryRenderer,
                recordingRenderer: RecordingRenderer,
                shortResultRenderer: ShortResultRenderer,
                callResultRenderer: CallResultRenderer,
                leadLinkRenderer: LeadLinkRenderer
            }
        };
    }

    componentDidMount() {
        this.refreshInterval = setInterval(() => {
            if (this.gridApi && this.props.isRunning) {
                // Refresh the server-side data store without losing scroll position
                if (typeof this.gridApi.refreshServerSide === 'function') {
                    this.gridApi.refreshServerSide({ purge: false });
                } else if (typeof this.gridApi.refreshServerSideStore === 'function') {
                    this.gridApi.refreshServerSideStore({ purge: false });
                }
            }
        }, 3000);
    }

    componentWillUnmount() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }
    
    componentDidUpdate(prevProps) {
        if (this.props.triggerInterestedFilter !== prevProps.triggerInterestedFilter && this.props.triggerInterestedFilter > 0) {
            if (this.gridApi) {
                this.gridApi.setFilterModel({
                    short_result: {
                        filterType: 'set',
                        values: ['INTERESTED', 'SHARE_ON_WHATSAPP', 'SHARED_POINT_OF_CONTACT', 'MEETING_BOOKED', 'GAVE_EMAIL']
                    }
                });
                this.gridApi.onFilterChanged();
            }
        }
    }
    
    onGridReady = (params) => {
        this.gridApi = params.api;
        params.api.setServerSideDatasource({ getRows: this.getRows });
    }

    getRows = (params) => {
        fetch(`/api/getvoicecampaigndetails/${this.props.crid}`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('jwttoken')}`
            },
            body: JSON.stringify(params.request)
        })
        .then(resp => resp.json())
        .then(data => {
            if (data.rows) {
                params.successCallback(data.rows, data.lastRow);
            } else {
                params.failCallback();
            }
        })
        .catch(err => {
            console.error("Error fetching rows:", err);
            params.failCallback();
        });
    }

    showTranscript = (text) => {
        this.setState({ showTranscriptModal: true, currentTranscript: text });
    }

    showSummary = (text) => {
        this.setState({ showSummaryModal: true, currentSummary: text });
    }

    // showLead = (leadid, db) => {
    //     this.setState({ showLeadModal: true, currentLeadId: leadid, currentLeadDb: db });
    // }

    render() {
        return (
            <div className="h-100 w-100 p-2">
                <div className="ag-theme-alpine" style={{ height: "calc(100vh - 200px)", width: "100%" }}>
                    <AgGridReact
                        columnDefs={this.state.columnDefs}
                        deltaRowDataMode={true}
                        rowModelType={this.state.rowModelType}
                        getRowId={(params) => params.data.id}
                        onGridReady={this.onGridReady}
                        context={{ showTranscript: this.showTranscript, showSummary: this.showSummary}}
                        pagination={true}
                        paginationPageSize={50}
                        cacheBlockSize={50}
                        components={this.state.frameworkComponents}
                        defaultColDef={{ 
                            resizable: true, 
                            filter: true,
                            sortable: true
                        }}
                        tooltipShowDelay={0}
                        tooltipHideDelay={2000}
                        // immutableData={true}
                    />
                </div>
                
                <Modal 
                    show={this.state.showTranscriptModal} 
                    onHide={() => this.setState({ showTranscriptModal: false })} 
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Call Transcript</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        <div className="p-3 bg-light rounded">
                            <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', margin: 0 }}>
                                {stripVoiceTags(this.state.currentTranscript) || "No transcript available."}
                            </pre>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showTranscriptModal: false })}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal 
                    show={this.state.showSummaryModal} 
                    onHide={() => this.setState({ showSummaryModal: false })} 
                    size="md"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Call Summary</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        <div className="p-3 bg-light rounded">
                            <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', margin: 0 }}>
                                {this.state.currentSummary || "No summary available."}
                            </pre>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showSummaryModal: false })}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* <Modal 
                    show={this.state.showLeadModal} 
                    onHide={() => this.setState({ showLeadModal: false, currentLeadId: null, currentLeadDb: null })} 
                    size="xl"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Lead Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto', padding: 0 }}>
                        {this.state.currentLeadId && this.state.currentLeadDb && (
                            <SingleLead leadid={this.state.currentLeadId} db={this.state.currentLeadDb} />
                        )}
                    </Modal.Body>
                </Modal> */}
            </div>
        );
    }
}

export default CampaignDetails;
